import React from 'react';
import {
  Autocomplete,
  TextField,
  SxProps,
} from "@mui/material";

interface MultiAutocompleteProps {
  value: string[];
  onChange: (value: string[]) => void;
  label: string;
  placeholder?: string;
  helperText?: string;
  options?: string[];
  chipSx?: SxProps;
  normalizeValue?: (value: string) => string;
  renderTags?: (value: string[], getTagProps: ({ index }: { index: number; }) => {}) => React.ReactNode;
  onPaste?: (event: React.ClipboardEvent<HTMLDivElement>) => void;
  inputValue?: string;
  onInputChange?: (event: React.SyntheticEvent, value: string) => void;
  customHeader?: React.ReactNode;
}

const MultiAutocomplete: React.FC<MultiAutocompleteProps> = ({
  value,
  onChange,
  label,
  placeholder,
  helperText,
  options = [],
  chipSx,
  normalizeValue,
  renderTags,
  onPaste,
  inputValue,
  onInputChange,
  customHeader,
}) => {
  return (
    <Autocomplete
      multiple
      freeSolo
      value={value}
      onChange={(_, newValue) => {
        const processedValue = newValue.map((item) => {
          const chipValue = (item as any).inputValue || item;
          return normalizeValue ? normalizeValue(chipValue) : chipValue;
        });
        onChange(processedValue);
      }}
      options={options}
      getOptionLabel={(option) => {
        if (!option) return '';
        if (typeof option === 'string') return option;
        return (option as any).inputValue || '';
      }}
      renderTags={renderTags}
      inputValue={inputValue}
      onInputChange={onInputChange}
      onPaste={onPaste}
      ListboxProps={{
        sx: customHeader ? { p: 0 } : undefined,
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          helperText={helperText}
          variant="outlined"
          fullWidth
        />
      )}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        return (
          <li key={key} {...otherProps}>
            {option}
          </li>
        );
      }}
      ListboxComponent={customHeader ? React.forwardRef<HTMLUListElement, React.HTMLAttributes<HTMLUListElement>>(
        ({ children, ...other }, ref) => (
          <ul {...other} ref={ref}>
            {customHeader}
            {children}
          </ul>
        )
      ) : undefined}
      ChipProps={{
        sx: chipSx,
      }}
    />
  );
};

export default MultiAutocomplete; 